import BdcDashboardStoresScreen from "../components/Bdc/Dashboard/Stores";

const BdcDashboardStoresPage = () => <BdcDashboardStoresScreen />;

export default BdcDashboardStoresPage;
